// src/components/CatylexSearch/catylexFormatters.ts
// Shared formatting helpers for CatylexSearch result cards.

export interface AgreementDateParts {
  year: string;
  month: string;
  day: string;
}

/** Parse an ISO agreement date into display parts (UTC to avoid off-by-one shifts). */
export const parseAgreementDate = (iso?: string): AgreementDateParts | null => {
  if (!iso) return null;
  const date = new Date(iso);
  if (isNaN(date.getTime())) return null;
  return {
    year: String(date.getUTCFullYear()),
    month: date.toLocaleString("en-US", { month: "short", timeZone: "UTC" }),
    day: String(date.getUTCDate()),
  };
};

/** Map a party role to a readable label, capitalizing unknown roles. */
export const roleLabel = (role: string): string => {
  const normalized = (role || "").toLowerCase();
  if (normalized === "away") return "Away Party";
  if (normalized === "home") return "Home Party";
  if (!role) return "Party";
  return role.charAt(0).toUpperCase() + role.slice(1);
};
